import { createFileRoute } from "@tanstack/react-router";

// Legacy slug → canonical /get-a-quote
export const Route = createFileRoute("/quote")({
  server: {
    handlers: {
      GET: async ({ request }) => {
        const url = new URL(request.url);
        return new Response(null, {
          status: 301,
          headers: { Location: `/get-a-quote${url.search}` },
        });
      },
    },
  },
});